import React, { useState } from "react";
import { notification, Space, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { RoleToLinkMapper } from "../../../utils/UrlUtils";
import Compliance from "../compliance/Compliance";
import { useReadMemory } from "../../../generic/hooks/useReadMemory";
import MemoryType from "../../../../service/memory/enum/MemoryType";
import AddEditTask from "../addedittask/AddEditTask";
import { strings } from "../../../utils/strings";
import SmartIcon from "../../../../components/generic/genericIcon/SmartIcon";
import Alert from "../alert/Alert";
import { complianceFormTemplateCode } from "../../../../components/recoil/complianceFormTemplateCodeRecoil";
import { useRecoilValue } from "recoil";

const TableActions = ({ careplan }) => {
  const navigate = useNavigate();
  const user = useReadMemory(MemoryType.USER);
  const [showAlert, setShowAlert] = useState(Boolean(careplan?.alerts?.length));
  const templateCode = useRecoilValue(complianceFormTemplateCode);
  

  const navigateToCareplanDetails = (carePlanId) => {
    navigate(
      RoleToLinkMapper(user?.jobTitle) +
        "request-for-volunteering-service?carePlanId=" +
        carePlanId
    );
    window.scrollTo(0, 0);
  };

  const opportunity = careplan?.opportunities?.find(
    (opportunity) => user?.userIdentifier === opportunity?.workforceIdentifier
  );

  const assignedOpportunities = careplan?.opportunities?.filter(
    (item) => item?.opportunityStatus === "Assigned"
  );

  const navigateToGoogleMaps = () => {
    const latitude =
      careplan?.patient?.serviceLocationType === "facility"
        ? careplan?.patient?.facility?.facilityLatitude
        : careplan?.patient?.latitude;
    const longitude =
      careplan?.patient?.serviceLocationType === "facility"
        ? careplan?.patient?.facility?.facilityLongitude
        : careplan?.patient?.longitude;

    if (latitude && longitude) {
      const googleMapUrl =
        "https://maps.google.com?q=" + latitude + "," + longitude;
      window.open(googleMapUrl);
    } else {
      notification.error({
        message: strings.NAVIGATE_TO_MAPS_ERROR,
        placement: "bottomRight",
      });
    }
  };

  return (
    <>
      <Space>
        {user?.jobTitle === "Volunteer Coordinator" && showAlert && (
          <Alert carePlanId={careplan?.id} setShowAlert={setShowAlert} />
        )}
        {user?.jobTitle === "Volunteer Coordinator" && templateCode && (
          <Compliance carePlanId={careplan.id} />
        )}
        <Tooltip title="Volunteer Request" placement="bottom">
          <>
            <SmartIcon
              iconKey={"careplan"}
              handleIconClick={() => navigateToCareplanDetails(careplan.id)}
            />
          </>
        </Tooltip>

        <Tooltip title="View Location" placement="bottom">
          <>
            <SmartIcon
              iconKey={"location"}
              handleIconClick={navigateToGoogleMaps}
            />
          </>
        </Tooltip>

        {Boolean(assignedOpportunities?.length) && (
          <AddEditTask careplan={careplan} opportunity={opportunity} />
        )}
      </Space>
    </>
  );
};

export default TableActions;
